import React, { useCallback, useEffect, useState } from "react";
import { useSharedTranslation } from "@/shared/contexts/TranslateContext";
import { useDispatch, useSelector } from "react-redux";
import classnames from "classnames";

import { TOAST_TYPE } from "../../constants";
import { selectorSystemMessages } from "../../store/system/selectors";
import { _sharedActionsSystem } from "../../store/system/actions";
import { copy } from "../../utils/copy";
import { tWithPrefixHandler } from "../../utils/multilang/i18n";

import styles from "./Toaster.module.scss";

const Toaster = () => {
  const { t } = useSharedTranslation();
  const dispatch = useDispatch();

  const messages = useSelector(selectorSystemMessages);

  const [stack, setStack] = useState([]);

  const pushToStack = useCallback((toast) => {
    setStack([toast]);
  }, []);

  const removeFromStackById = useCallback((uniqueId) => {
    setStack((stackOld) => stackOld.filter((toast) => toast.uniqueId !== uniqueId));
  }, []);

  // queue picking logic
  useEffect(() => {
    const [firstMessage] = messages;
    if (firstMessage?.message) {
      let msgFinal = "";

      if (Array.isArray(firstMessage.message)) {
        firstMessage.message.forEach((m) => {
          msgFinal += tWithPrefixHandler(t, m);
        });
      } else {
        msgFinal += tWithPrefixHandler(t, firstMessage.message);
      }

      pushToStack({
        type: firstMessage.type || TOAST_TYPE.notify,
        message: msgFinal,
        timestampClose: Date.now() + 1000 + (msgFinal ? msgFinal.length * 75 : 0),
        uniqueId: Math.random(),
      });

      dispatch(_sharedActionsSystem.toastSuccess(firstMessage));
    }
  }, [t, pushToStack, messages]);

  // auto-close logic
  useEffect(() => {
    let timeout;

    const toastNextToBeClosed = stack.sort((a, b) => b.timestampClose > a.timestampClose ? 1 : -1)[0];

    if (toastNextToBeClosed) {
      timeout = setTimeout(() => {
        setStack((stackOld) => stackOld.filter((toast) => toast !== toastNextToBeClosed));
      }, toastNextToBeClosed.timestampClose - Date.now());
    }

    return () => {
      clearTimeout(timeout);
    };
  }, [stack]);

  return (
    <>
      {stack.map((t) => {
        const { message, type, uniqueId } = t;
        return (
          <span
            key={uniqueId}
            className={classnames(styles["toast-view"], styles[type])}
            dangerouslySetInnerHTML={{ __html: message }}
            onClick={() => {
              copy(message);
              removeFromStackById(uniqueId);
            }}
          />
        );
      })}
    </>
  );
};

export default Toaster;
